import { Injectable } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

import { ConfirmModalContent } from 'models/modal.model';
import { ConfirmModalComponent } from 'shared/confirm-modal/confirm-modal.component';

import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {
  constructor(
    private modalService: ModalService
  ) { }

  private bsModalRef: BsModalRef | undefined = undefined;

  show(
    headingKey: string,
    options?: {
      cancel?: string;
      confirm?: string;
      showCancel?: boolean;
      showConfirm?: boolean;
      hideCloseIcon?: boolean;
      cssClass?: string;
      content?: ConfirmModalContent[]
    }
  ): ConfirmModalService {
    this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      class: options && options.cssClass ? options.cssClass : 'modal-sm',
      initialState: options ? { ...options, headingKey } : { headingKey }
    });

    return this;
  }

  onConfirm(): Observable<boolean> {
    if (this.bsModalRef) {
      return this.bsModalRef.content.confirmed
        .pipe(
          take(1),
          filter((val: boolean) => val),
          tap(() => {
            this.bsModalRef = undefined;
          })
        );
    }

    return of();
  }

  onAction(): Observable<boolean> {
    if (this.bsModalRef) {
      return this.bsModalRef.content.confirmed
        .pipe(
          take(1),
          tap(() => {
            this.bsModalRef = undefined;
          })
        );
    }

    return of();
  }
}
